import FormWithProvider from 'components/forms/form/Form';
import {
  addCustomFieldSchema,
  AddCustomFieldType,
} from './AddCustomField.schema';
import AddCustomFieldModalFormFields from './AddCustomFieldModalFormFields';

const AddCustomFieldModal = ({
  modalId,
  handleSubmit,
}: {
  modalId: string;
  handleSubmit: (values: any) => void;
}) => {
  return (
    <FormWithProvider
      schema={addCustomFieldSchema()}
      onSubmit={handleSubmit}
      horizontal
      defaultValues={{
        name: '',
        type: AddCustomFieldType.TEXT,
      }}
    >
      <AddCustomFieldModalFormFields modalId={modalId} />
    </FormWithProvider>
  );
};

export default AddCustomFieldModal;
